/**
 * Utilidad para validación y formateo de RUT chileno
 */

/**
 * Valida un RUT chileno según el algoritmo del dígito verificador
 * @param {string} rut - RUT a validar (puede incluir puntos y guión)
 * @returns {boolean} - true si el RUT es válido, false en caso contrario
 */
export const validarRUT = (rut) => {
  // Limpiar el RUT de puntos y guiones
  const rutLimpio = rut.replace(/\./g, "").replace(/-/g, "");
  
  if (rutLimpio.length < 8 || rutLimpio.length > 10) {
    return false;
  }
  
  // Separar el cuerpo del dígito verificador
  const cuerpo = rutLimpio.slice(0, -1);
  const dv = rutLimpio.slice(-1).toUpperCase();
  
  // Calcular el dígito verificador
  let suma = 0;
  let multiplicador = 2;
  
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo.charAt(i)) * multiplicador;
    multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
  }
  
  const dvEsperado = 11 - (suma % 11);
  const dvCalculado = dvEsperado === 11 ? "0" : dvEsperado === 10 ? "K" : dvEsperado.toString();
  
  return dv === dvCalculado;
};

/**
 * Formatea un RUT chileno con puntos y guión
 * @param {string} rut - RUT a formatear (sin puntos ni guión)
 * @returns {string} - RUT formateado (ej: 12.345.678-9)
 */
export const formatearRUT = (rut) => {
  // Limpiar el RUT
  const rutLimpio = rut.replace(/\./g, "").replace(/-/g, "").toUpperCase();
  
  if (rutLimpio.length <= 1) return rutLimpio;
  
  // Separar cuerpo y dígito verificador
  const cuerpo = rutLimpio.slice(0, -1);
  const dv = rutLimpio.slice(-1);
  
  // Formatear cuerpo con puntos
  let cuerpoFormateado = "";
  let contador = 0;
  
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    if (contador === 3) {
      cuerpoFormateado = "." + cuerpoFormateado;
      contador = 0;
    }
    cuerpoFormateado = cuerpo.charAt(i) + cuerpoFormateado;
    contador++;
  }
  
  return `${cuerpoFormateado}-${dv}`;
};
